import { bootstrapApplication } from '@angular/platform-browser';
import { initDatadogRum } from '@core/monitoring/datadog-rum';
import { App } from './app/app';
import { appConfig } from './app/app.config';

initDatadogRum()
  .then((rumProviders) =>
    bootstrapApplication(App, {
      ...appConfig,
      providers: [...appConfig.providers, ...rumProviders],
    }),
  )
  .catch((err) => console.error(err));
